export interface PushEnv {
  hasServiceWorker: boolean;
  hasPushManager: boolean;
  hasNotification: boolean;
  permission: "default" | "granted" | "denied";
  ios: boolean;
  standalone: boolean;
}

// Returns null when push is fully available. Returns a human-readable reason
// string when it is not, so callers can surface the explanation to the user.
export function pushUnavailableReason(env: PushEnv): string | null {
  const capable = env.hasServiceWorker && env.hasPushManager && env.hasNotification;
  if (capable && env.permission !== "denied") return null;

  if (!capable) {
    if (env.ios && !env.standalone) {
      return "Push notifications are only available when this app is added to your Home Screen.";
    }
    return "Your browser does not support push notifications.";
  }

  // Capabilities present but permission blocked.
  return "Notifications are blocked. To enable them, change your browser settings and reload.";
}
